import { render, staticRenderFns } from "./instockAchievement.vue?vue&type=template&id=9904f80a&scoped=true&"
import script from "./instockAchievement.vue?vue&type=script&lang=js&"
export * from "./instockAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904f80a",
  null
  
)

export default component.exports